export const reInitializeRelianceIPAInitialValues = (
  initialValues,
  quickQuoteValues
) => {
  console.log("quickQuoteValues: ", quickQuoteValues);
  // Iterate over initialValues
  for (let key in initialValues) {
    const value = initialValues[key];

    // Check if value is an array
    if (Array.isArray(value)) {
      initialValues[key] = Array.from(
        { length: quickQuoteValues.number_of_insured },
        (_, ind) => {
          // Update fields based on quickQuoteValues
          if (key === "primaryDetails") {
            const currentInsured = quickQuoteValues?.insureds?.[ind];
            const selectedTable =
              currentInsured?.IsTableA === "true"
                ? "IsTableA"
                : currentInsured?.IsTableB === "true"
                ? "IsTableB"
                : currentInsured?.IsTableC === "true"
                ? "IsTableC"
                : "";

            return {
              ...value[0], // Use the first object as the initial template
              RelationshipWithProposerID:
                quickQuoteValues.insureds[ind].RelationshipWithProposerID,
              FirstName: quickQuoteValues.insureds[ind].FirstName,
              IsEarningMember:
                quickQuoteValues.insureds[ind].AnnualIncome > 0
                  ? "true"
                  : "false",
              AnnualIncome: quickQuoteValues.insureds[ind].AnnualIncome,
              OccupationID: quickQuoteValues.insureds[ind].OccupationID,
              TableOfBenifits: selectedTable,
              SumInsured: quickQuoteValues.insureds[ind].TotalCapitalSI,
              Gender: getGender(quickQuoteValues, ind),
            };
          }
          return initialValues;
        }
      );
    } else {
      // Check if value is an object
      if (key === "proposerDetails") {
        const today = new Date();
        const policyStartDate = new Date(today);
        policyStartDate.setDate(today.getDate() + 1);

        const policyEndDate = new Date(
          today.getFullYear() + 1,
          today.getMonth(),
          today.getDate()
        );

        initialValues[key] = {
          ...value,
          ForeName: quickQuoteValues.insureds[0].FirstName,
          OccupationID: quickQuoteValues.insureds[0].OccupationID,
          Gender: getGender(quickQuoteValues, 0),
          PolicyStartDate: policyStartDate,
          PolicyEndDate: policyEndDate,
          RiskDetails: {
            ...value.RiskDetails,
            MemberCount: quickQuoteValues.number_of_insured,
            MembertoInsure: quickQuoteValues.number_of_insured,
            SumInsured: quickQuoteValues.sumInsuredValue,
          },
        };
      }
    }
  }

  return initialValues;
};

const getGender = (quickQuoteValues, i) => {
  const { proposer_gender, insureds } = quickQuoteValues;
  const relationshipID = insureds[i].RelationshipWithProposerID;

  if (proposer_gender === "Male") {
    if (relationshipID === "345") return 0;
    if (relationshipID === "320") return 1;
  } else if (proposer_gender === "Female") {
    if (relationshipID === "345") return 1;
    if (relationshipID === "320") return 0;
  }

  return relationshipID === "1989" ? 1 : relationshipID === "1988" ? 0 : "";
};
